<template>
  <j-search-select-tag :placeholder="placeholder" @change="onChange" :value="value" :dictOptions="searchOptions"></j-search-select-tag>
</template>
<script>
import {ajaxGetDictItems} from '@/api/api'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

export default {
  name: 'OrgSelect',
  components: {
    JSearchSelectTag
  },
  props: {
    dictCode: String,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number],
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    }
  },
  data() {
    return {
      searchOptions: [],
    };
  },
  created() {
    this.initAreaData();
  },
  methods: {
    onChange(e) {
      let val;
      val = e;
      this.$emit('change', val);
    },
    initAreaData(){
        //根据字典Code, 初始化字典数组
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          if (res.success) {
//                console.log(res.result);
            this.searchOptions = res.result;
          }
        })
      }
  },
};
</script>